import { Typography } from '@mui/material';
import {
  SimpleForm,
  SelectInput,
  NumberInput,
  BooleanInput,
  ArrayInput,
  SimpleFormIterator,
  Toolbar,
  SaveButton,
  useNotify,
  Labeled,
} from 'react-admin';

const UserConfigToolbar = (props: any) => {
  const notify = useNotify();
  // const redirect = useRedirect();
  const onSuccess = (response: any) => {
    notify(`User configuration saved!`);
    // redirect('/posts');
  };

  return (
    <Toolbar {...props}>
      <SaveButton label="Save Configuration" />
    </Toolbar>
  );
};

const UserConfigForm = ({
  userId,
  save,
  record,
}: {
  userId: string;
  save?: any;
  record?: any;
}) => {
  const notify = useNotify();
  return (
    <SimpleForm
      record={record}
      // onSubmit={(values) => console.log('values', values)}
      onSubmit={(values, e) => {
        e?.preventDefault();
        e?.stopPropagation();
        if (!save) return;
        notify(`User configuration saved!`);
        save(values);
      }}
      defaultValues={{
        userId,
      }}
      toolbar={<UserConfigToolbar />}
    >
      <Typography variant="h6" gutterBottom>
        Settings
      </Typography>
      <Labeled label="Daily Transaction Limit">
        <NumberInput source="dailyTransactionLimit" />
      </Labeled>
      <Labeled label="User Account Status">
        <BooleanInput source="accountLocked" />
      </Labeled>
    </SimpleForm>
  );
};

export default UserConfigForm;
